
import type { StorageItem } from "./interfaces"
export function getDynamicTimes() {
    const now = new Date()
    const totalMin = now.getHours() * 60 + now.getMinutes()
    const offset = Math.ceil(totalMin / 15)
    const times = Array.from({ length: 96 }, (_, i) => {
        const slot = (i + offset) % 96
        const h = Math.floor(slot / 4) % 24
        const m = (slot % 4) * 15
        return `${ String(h).padStart(2, '0') }:${ String(m).padStart(2, '0') }`
    })
    return times;
}
export const isToday = (dateString: string) => {
    const inputDate = new Date(dateString.split('/').reverse().join('-')) // Convert to YYYY-MM-DD format
    const today = new Date()

    return inputDate.getDate() === today.getDate() &&
        inputDate.getMonth() === today.getMonth() &&
        inputDate.getFullYear() === today.getFullYear()
}
export function getCurrentTime() {
    const now = new Date()
    const totalMin = now.getHours() * 60 + now.getMinutes()
    const rounded = Math.ceil(totalMin / 15) * 15
    const h = Math.floor(rounded / 60) % 24
    const m = rounded % 60
    return `${ String(h).padStart(2, '0') }:${ String(m).padStart(2, '0') }`
}


export const ticketStorage = {
    getItem(key: string): any {
        const storedItem = localStorage.getItem(key)
        if (!storedItem) return null

        const parsedItem: StorageItem = JSON.parse(storedItem)

        if (parsedItem.expiry && new Date(parsedItem.expiry) < new Date()) {
            this.removeItem(key)
            return null
        }

        return parsedItem.value
    },
    setItem(key: string, value: any, expiryInSeconds: number = 60 * 5): void {
        const expiryDate = new Date()
        expiryDate.setSeconds(expiryDate.getSeconds() + expiryInSeconds)

        const itemToStore: StorageItem = {
            value,
            expiry: expiryDate.toISOString(),
        }

        localStorage.setItem(key, JSON.stringify(itemToStore))
    },
    removeItem(key: string): void {
        localStorage.removeItem(key)
    },
}
